import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Routines } from './components/routines';
import { routinesPaths } from './routinesPaths';

export const routinesRoutes = [
  {
    path: `${routinesPaths.root}/*`,
    element: <Routines />,
    handle: {
      header: {
        titleKey: 'assets.list.routines',
        icon: 'format-list-checks',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
];
